import apiClient from './client'
import { ensureArray } from '../utils/array'

export interface DocFile {
  title: string
  path: string
  filename: string
}

export interface DocCategory {
  category: string
  folder: string
  files: DocFile[]
}

export interface DocContent {
  title: string
  path: string
  content: string
}

export const documentacaoApi = {
  list: async (): Promise<DocCategory[]> => {
    const response = await apiClient.get<DocCategory[]>('/config/docs')
    return ensureArray<DocCategory>(response.data)
  },

  getFile: async (path: string): Promise<DocContent> => {
    const response = await apiClient.get<DocContent>('/config/docs/file', {
      params: { path },
    })
    return response.data
  },
}
